import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateDiscountStatusReduxParams } from '~types/feat/approval';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TransactionStatusEnum } from '~utils/enums';

export default function* watchUpdateDiscountStatus(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalUpdateDiscountStatusAttempt', handleUpdateDiscountStatus, api);
}

function* handleUpdateDiscountStatus(api: ApprovalGateway, data: PayloadAction<TUpdateDiscountStatusReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        id,
        status,
    } = data.payload;

    const response = yield* call([api, api.updateDiscountStatus], {
        authToken,
        id,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalUpdateDiscountStatusFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const successMessage = status === TransactionStatusEnum.Approved
            ? SuccessMessages.DiscountUpdateApprovalSuccess
            : status === TransactionStatusEnum.Rejected
                ? SuccessMessages.DiscountUpdateRejectSuccess
                : '';

        yield put(combinedActions.approvalSetConfirmUpdateDiscountStatusModalIsOpen(false));
        yield put(combinedActions.approvalGetPendingDiscountListingAttempt());
        yield put(combinedActions.approvalUpdateDiscountStatusSuccess());

        toast.success(successMessage);
    }
}
